"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTermsPanelCms = void 0;
var OrderTermsPanelCms = /** @class */ (function () {
    function OrderTermsPanelCms() {
        this.orderTermsTitleLabel = 'Terms';
        this.termsAgreedThanksLabel = 'Thanks for agreeing to the terms.';
        this.editLinkAriaLabel = 'Review terms information';
        this.cancelCTALabel = 'Cancel';
        this.acceptTermsCTALabel = 'Accept terms';
        this.reAcceptTermsAlertTxt = 'Because you\'ve made changes to your order, please read and agree to the new terms.';
    }
    return OrderTermsPanelCms;
}());
exports.OrderTermsPanelCms = OrderTermsPanelCms;
//# sourceMappingURL=orderTermsPanelCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/OrderTermsPanel/orderTermsPanelCms.cms.js
// module id = 2024
// module chunks = 8